export default ".mat-dialog-content {\n  height: auto;\n}";